import { useEffect, useState } from 'react';
import { withData } from "../../../DataController";
import { useRemote } from '../../../Utils/Utils';
import { logoForPath } from '../../../Utils/brandImage';
// import { toastDanger, toastSuccess } from '../../popups/Toast';
// import TextInput from '../../Input/TextInput';
// import Button from '../../Buttons/Button';
import Checkbox from '../../Checkbox';
import SidebarExtensionWrapper from './SideBarExtensionWrapper';
import SideBarSection from './SideBarSection';
import DragSourceElement from '../../Daggable/DragSourceElement';
import DragDropTarget from '../../Daggable/DragDropTarget';
import Tooltip from '../../popups/Tooltip';
import "./OptionsSidebarExtension.scss";

const OptionsSidebarExtension = ({ slideIn, slideOut, template, optionalPages, setOptionalPages, loadingLocalData, data }) => {
	const remote = useRemote();
	const [logoElement, setLogoElement] = useState({ selected: false, label: "Logo", index: 0, align: "left" });
	const [titleElement, setTitleElement] = useState({ selected: false, label: "Title", index: 1, align: "center" });
	const [dateElement, setDateElement] = useState({ selected: false, label: "Date", index: 2, align: "center" });
	const [numberElement, setNumberElement] = useState({ selected: false, label: "Number", index: 3, align: "right" });
	const [footerContent, setFooterContent] = useState([]);
	const [draggedElement, setDraggedElement] = useState(null)
	const [footerContentCopy, setFooterContentCopy] = useState([])
	const [disabledLogo, setDisabledLogo] = useState(false);
	// const [numRows, setNumRows] = useState([]);
	// const [numCols, setNumCols] = useState([]);

	// const setClipboard = (text) => {
	// 	const type = "text/html";
	// 	const blob = new Blob([text], { type });
	// 	const data = [new window.ClipboardItem({ [type]: blob })];

	// 	navigator.clipboard.write(data).then(
	// 		() => { toastSuccess("Table copied, please paste into the editor") },
	// 		() => { toastDanger("Copy failed, you might need to give permission to your browser") }
	// 	);
	// }

	// const createTable = () => {
	// 	if (!window.ClipboardItem) {
	// 		toastDanger("Unfortunately your browser does not support copying to the clipboard");
	// 		return;
	// 	}
	// 	let string = "<table>";
	// 	for (let r = 0; r < (numRows || 2); r++) {
	// 		let row = "<tr>";
	// 		for (let c = 0; c < (numCols || 2); c++) {
	// 			row += "<td width='10'></td>";
	// 		}
	// 		row += "</tr>";
	// 		string += row;
	// 	}
	// 	string += "</table>";

	// 	setClipboard(string);
	// }

	// the footer logo is the document's brand's, so ask again when its template or tickers change
	const tickerList = (data.tickers || []).join(',');

	useEffect(() => {
		remote.get(logoForPath(data)).then(fetched => {
			// the logo the footer would show: the fund's mapped brand's, else the master brand's (a link or bytes)
			const brandLogo = fetched?.logo;
			setDisabledLogo(brandLogo ? false : true);

			if (data && data.localContentData && data.localContentData.PAGEFOOTER) {
				const parsedFooter = JSON.parse(data.localContentData.PAGEFOOTER) || []
				if (parsedFooter.length > 0) {
					const updatedFooter = parsedFooter.map(item => {
						if (item.label === "Logo") {
							const updatedLogo = { ...item, selected: !brandLogo ? false : item.selected };
							setLogoElement(updatedLogo);
							return updatedLogo;
						}
						if (item.label === "Title") {
							setTitleElement(item);
							return item;
						}
						if (item.label === "Date") {
							setDateElement(item);
							return item;
						}
						if (item.label === "Number") {
							setNumberElement(item);
							return item;
						}
					})
					setFooterContent(updatedFooter)
				}
			} else {
				setFooterContent([logoElement, titleElement, dateElement, numberElement])
			}
		})
	}, [data.localContentData.PAGEFOOTER, data.templateName, data.tickerGroup, tickerList])



	const includePage = (page) => {
		const index = optionalPages.indexOf(page);
		if (index > -1) {
			optionalPages.splice(index, 1);
		} else {
			optionalPages.push(page);
		}
		setOptionalPages(optionalPages);
		data.updateLocalData("OPTIONAL_PAGES", JSON.stringify(optionalPages), "SIDEBAR");
	}

	function updateFooter(label, selected) {
		const updatedList = footerContent.map(item => {
			if (item.label === label) {
				return { ...item, selected };
			}
			return item;
		})
		const updatedListWithAlignments = updatedList.map(item => {
			return { ...item, align: getElementAlignment(item.label, updatedList) }
		})
		const payload = JSON.stringify(updatedListWithAlignments);
		data.updateLocalData('PAGEFOOTER', payload, 'SIDEBAR', 'PAGEFOOTER')
	}

	function onMouseDown(index) {
		setDraggedElement(index)
	}

	function getSelection(elementsList) {
		const elements = elementsList.filter((element, idx) => idx === draggedElement);
		return elements;
	}

	function onHover(elementIndex) {
		const movingElement = footerContent[draggedElement]
		const filteredSteps = footerContent.filter((step) => step.label !== movingElement.label)
		filteredSteps.splice(elementIndex, 0, movingElement)
		setFooterContentCopy(filteredSteps)
	}

	function getElementAlignment(label, filteredSteps) {
		const selectedElements = filteredSteps.filter((ele) => ele.selected);
		const selectedElemenstWithNewIndex = selectedElements.map((ele, idx) => ({ ...ele, index: idx }));
		const selectedElementsObj = selectedElemenstWithNewIndex.length > 0 ? selectedElemenstWithNewIndex.reduce((a, c) => ({ ...a, [c.label]: c }), {}) : null
		let alignment = "";
		if (selectedElementsObj && selectedElementsObj[label]) {
			alignment = selectedElementsObj[label].index === 0 ? "left" : selectedElementsObj[label].index === selectedElements.length - 1 ? "right" : "center"
		}
		return alignment;
	}

	function updateElements(elements, elementIndex) {
		const oldSetpIndex = draggedElement
		const movingElement = footerContent[draggedElement]
		const filteredSteps = footerContent.filter((ele, index) => index !== oldSetpIndex)
		filteredSteps.splice(elementIndex, 0, movingElement)
		const sortedElement = filteredSteps.map((ele, idx) => {
			const updatedElement = { ...ele, index: idx, align: getElementAlignment(ele.label, filteredSteps) }
			return updatedElement;
		}).sort((a, b) => a.index - b.index);

		const payload = JSON.stringify(sortedElement);
		data.updateLocalData('PAGEFOOTER', payload, 'SIDEBAR', 'PAGEFOOTER')
		setDraggedElement(null)
	}

	function renderStep(element, idx, dragging) {
		return (<>
			<div className={`page-footer-option-wrapper${element?.selected ? " selected" : ""}`} key={idx + 1 + "-" + idx} >
				<div className='page-footer-option-drag-handdle'>
					<i
						className={`material-icons${footerContent && footerContent.length === 1 ? " disabled" : ""}`}
						onMouseDown={() => footerContent && footerContent.length > 1 ? onMouseDown(idx) : null}
						onClick={() => footerContent && footerContent.length > 1 ? dragging ? setDraggedElement(null) : setDraggedElement(idx) : null}
					>
						drag_indicator
					</i>
				</div>
				<Tooltip disabled={element?.label !== 'Logo' || (element.label === 'Logo' && !disabledLogo)} label={element?.label === "Logo" && disabledLogo ? "Logo is not set in the brand settings" : ""}>
					<div className='page-footer-option' key={idx} index={idx}>
						<Checkbox disabled={element?.label === 'Logo' && disabledLogo} label={element?.label} checked={element?.selected} onChange={() => updateFooter(element?.label, !element?.selected, idx)} />
					</div>
				</Tooltip>
			</div>
		</>
		)
	}


	return (
		<SidebarExtensionWrapper noPadding position="right" shadow slideIn={slideIn} slideOut={slideOut}>
			<div className="sidebar-section-header pl-m pr-m pb-l align-items-center display-md-fle justify-content-between"><h4>Template Options</h4></div>
			{template &&
				template.optionalPages &&
				template.pages
					.filter((page) => page.optional)
					.map((page, idx) => {
						return (
							<SideBarSection header="Optional Pages" separator>
								<Checkbox
									key={idx}
									label={"Include " + page.name}
									checked={optionalPages && optionalPages.includes(page.name)}
									onChange={() => includePage(page.name)}
									disabled={loadingLocalData}
								></Checkbox>
							</SideBarSection>
						);
					})}
			{/* <SideBarSection header="Insert table" separator>
				<TextInput label="Number of Rows" onChange={(e) => setNumRows(e.target.value)} size="small" placeHolder={"Num Rows"} value={numRows} />
				<TextInput className="mt-xl mb-xl" label="Number of Columns" onChange={(e) => setNumCols(e.target.value)} size="small" placeHolder={"Num Cols"} value={numCols} />
				<Button classNames="back-to-home-button" rounded onClick={() => createTable()}>
					Copy table to clipboard
				</Button>
			</SideBarSection> */}
			<SideBarSection header="Page Footer Order (Left to Right)" separator className='page-footer-settings-wrapper'>
				{footerContent.map((element, index) => {
					const dropping = draggedElement !== null //&& draggedElement !== index
					const dragging = draggedElement === index

					return (dragging ?
						<>
							<DragSourceElement
								key={'step-dragged' + index}
								element={<DragDropTarget
									dropArea={renderStep(element, index, dropping, dragging)}
									updateElements={updateElements}
									elementIndex={index}
									parentIndex={null}
									onHover={onHover}
								/>}
								seleccion={draggedElement}
								elementIndex={draggedElement}
								dragList={() => getSelection(footerContentCopy)}
								noShallowCopy={true}
							/>
						</> : dropping ?
							<DragDropTarget
								dropArea={renderStep(element, index, dropping, dragging)}
								updateElements={updateElements}
								elementIndex={index}
								parentIndex={null}
								onHover={onHover}
								key={'step-dropped-' + index}
							/>
							: renderStep(element, index, dropping, dragging)
					)
				}
				)}
			</SideBarSection>
		</SidebarExtensionWrapper>
	);
}

export default withData(OptionsSidebarExtension);